import { render, staticRenderFns } from "./collectionSchedule.vue?vue&type=template&id=599e4b6a&scoped=true&"
import script from "./collectionSchedule.vue?vue&type=script&lang=js&"
export * from "./collectionSchedule.vue?vue&type=script&lang=js&"
import style0 from "./collectionSchedule.vue?vue&type=style&index=0&id=599e4b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e4b6a",
  null
  
)

export default component.exports